
import React from 'react';

const Hero: React.FC = () => {
  const scrollTo = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="relative pt-32 pb-16 px-6 border-b border-zinc-800">
      {/* Subtle Hive Logo Watermark */}
      <div className="absolute top-1/2 right-20 -translate-y-1/2 opacity-[0.04] pointer-events-none hidden lg:block">
        <i className="fa-brands fa-hive text-[400px] text-white"></i>
      </div>

      <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 relative z-10">
        <div className="lg:col-span-8">
          <div className="font-mono text-red-600 text-xs mb-4 uppercase tracking-[0.3em] flex items-center gap-3">
            <span className="w-8 h-px bg-red-600"></span>
            Blockchain Infrastructure & Tooling
            <span className="flex items-center gap-1 ml-2 text-zinc-600">
              <i className="fa-brands fa-hive text-[10px]"></i>
              CORE_PROTOCOL_01
            </span>
          </div>
          <h1 className="text-5xl md:text-8xl font-black text-white leading-none tracking-tighter mb-8 uppercase">
            Architecting <br /> 
            The <span className="text-zinc-500">Hive</span> Chain.
          </h1>
          <p className="text-xl text-zinc-400 max-w-2xl font-light leading-relaxed mb-10">
            Advanced open-source development for the Hive ecosystem. Specializing in high-throughput indexing engines, node infrastructure, and decentralized interface layers.
          </p>
          <div className="flex items-center gap-4">
            <button 
              onClick={() => scrollTo('work')}
              className="px-8 py-4 bg-white text-black font-mono text-xs uppercase tracking-widest font-bold hover:bg-red-600 hover:text-white transition-colors cursor-pointer border-none"
            >
              Registry_Access
            </button>
            <a 
              href="https://github.com/louis-88" 
              target="_blank"
              rel="noopener noreferrer"
              title="GitHub Profile"
              className="w-14 h-14 border border-zinc-700 flex items-center justify-center text-zinc-400 hover:text-white hover:bg-zinc-800 transition-all no-underline"
            >
              <i className="fa-brands fa-github text-2xl"></i>
            </a>
            <div className="hidden sm:flex flex-col font-mono text-[9px] text-zinc-700 ml-4 border-l border-zinc-800 pl-4 uppercase tracking-widest">
              <span>Source_Verified</span>
              <span>Branch_Main</span>
            </div>
          </div>
        </div>
        
        <div className="lg:col-span-4 border-l border-zinc-800 pl-12 hidden lg:flex flex-col justify-center">
          <div className="space-y-10">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-zinc-800 flex items-center justify-center text-red-600">
                <i className="fa-brands fa-hive text-xl"></i>
              </div>
              <div>
                <div className="font-mono text-[10px] text-zinc-600 uppercase mb-1">Primary_Network</div>
                <div className="text-white font-bold tracking-tight">HIVE_BLOCKCHAIN</div>
              </div>
            </div>
            <div>
              <div className="font-mono text-[10px] text-zinc-600 uppercase mb-2">Technical_Focus</div>
              <div className="text-white font-bold">L2 Tooling & Smart Ops</div>
            </div>
            <div className="pt-6 border-t border-zinc-900">
              <div className="font-mono text-[10px] text-zinc-600 uppercase mb-3">Runtime_Status</div>
              <div className="flex items-center gap-3 text-green-500 font-mono text-xs bg-green-500/5 px-3 py-2 border border-green-500/20 w-fit">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>
                SYSTEMS_ONLINE
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
